import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import LandingPage from '../views/LandingPage.vue';

Vue.use(VueRouter);

const BrowseQuotes = () => import('../views/BrowseQuotes.vue');
const ShareQuotes = () => import('../views/ShareQuotes.vue');

const localStorageExists = localStorage != null;
const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    props: true,
    component: LandingPage,
  },
  {
    path: '/browse',
    name: 'browse.quotes',
    props: true,
    component: BrowseQuotes,
    meta: {
      hideFooter: true,
    },
  },
  {
    path: '/share',
    name: 'share.quotes',
    component: ShareQuotes,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

export default router;
